import { Box, Button, Container, Paper } from '@mui/material';
import { Subheader } from 'components';
import EditorialDetails from 'features/editorials/EditorialDetails';
import { useAlerts, useEditorials } from 'hooks';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const EditorialShow = ({ ...props }) => {
	const navigate = useNavigate();
	const { id } = useParams();

	const { isLoading, isLoaded, editorial, findEditorial } = useEditorials({
		id: id
	});

	const handleEditClick = () => navigate(`/editorials/${id}/edit`);

	useEffect(() => {
		if (id) findEditorial(id);
	}, []);

	return (
		<>
			<Subheader
				title={isLoading ? 'Loading...' : editorial.title}
				buttons={[
					<Button onClick={handleEditClick} color="primary" variant="contained">
						Edit
					</Button>
				]}
			/>
			<Container>
				<Paper>
					<Box p={4}>
						<EditorialDetails editorial={editorial} />
					</Box>
				</Paper>
			</Container>
		</>
	);
};

export default EditorialShow;
